import React from "react";
import { AnimateFrame } from "../../components/AnimateFrame";
import { Header } from "../../components/Header";
import { WhoIAm } from "../../components/WhoIAm";
import { Container } from "../../style/GlobalStyle";

export const WhoIAmPage = () => {
  return (
    <Container>
      <Header />
      <AnimateFrame>
        <WhoIAm />
      </AnimateFrame>
    </Container>
  );
};
